
      let loadingText = document.getElementById("loading-text");
      let loadingScreen = document.getElementById("loading-screen");
      let rootElement = document.getElementById("root");

      let progress = 0;
      let loadingComplete = false;

      function updateProgress() {
        if (progress < 95) { // Stop at 95% to allow smooth transition
          progress += 5;
          loadingText.textContent = `Loading... ${progress}%`;
        }
      }

      let progressInterval = setInterval(updateProgress, 100);

      window.onload = function () {
        loadingComplete = true;
        clearInterval(progressInterval);
        loadingScreen.style.display = "none";
        rootElement.style.display = "block";
      };
    